import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
import es from './es'
import ar from './ar'
import pt from './pt'
import ja from './ja'
import ko from './ko'
import fa from './fa'
import tr from './tr'
import vi from './vi'
import th from './th'
import ru from './ru'

Vue.use(VueI18n)

const LOCALE_KEY = 'im_locale'

const i18n = new VueI18n({
  locale: localStorage.getItem(LOCALE_KEY) || 'zh',
  fallbackLocale: 'en',
  messages: { zh, en, es, ar, pt, ja, ko, fa, tr, vi, th, ru }
})

// 切换语言并持久化
export const setLocale = (locale) => {
  i18n.locale = locale
  localStorage.setItem(LOCALE_KEY, locale)
}

export default i18n
